var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apollo-mutation',{attrs:{"mutation":_vm.DELETE_PROJECT,"variables":{ id: _vm.project.id },"update":_vm.removeFromCache,"tag":null},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var mutate = ref.mutate;
var loading = ref.loading;
return [_c('s-button',{attrs:{"color":"error","is-loading":loading,"title":_vm.$t('destroy'),"icon":"trash"},on:{"click":function($event){return _vm.confirmDelete(mutate)}}},[_vm._t("default")],2)]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }